import {MessagesRequest, MessagesResponse, OpsOrderId} from 'types/orderTypes'
import {opsApi} from './apis'

export const composeMessage = (opsOrderId: OpsOrderId, payload: MessagesRequest) => {
  return opsApi.post<MessagesResponse>(`orders/${opsOrderId}/messages`, payload)
}
